import React, { useCallback, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dropzone, { useDropzone } from "react-dropzone";
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./index.scss";
import { Button, Col, Input, Row } from "reactstrap";
import HeadBlock from "./HeadBlock";
import UploadedFile from "./UploadedFile";
import { upload, getPrivileges } from "./../../context/actions/file";
import { getDocumentTypes } from "./../../context/actions/document";
import { fileType, toasterConfig, roleItems, src, pagination } from "../../utils/constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UploadTime from "./UploadTime";
import PageHeader from "../../components/common/PageHeader";
import UploadFileMessage from "./UploadFileMessage";
import DropdownList from "./DropdownList";
import DocumentType from "./DocumentType";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import axios from "axios";
import { Treebeard } from 'react-treebeard';
import * as filters from '../../components/common/TreeBeard/filters';
import decorators from "react-treebeard/dist/components/Decorators";
import defaultTheme from "react-treebeard/dist/themes/default";
import useComponentVisible from '../../components/common/TreeBeard/useComponentVisible';
const MySwal = withReactContent(Swal);
let source = axios.CancelToken.source();
toast.configure();

const FileUpload = () => {
  const role = useSelector((state) => state?.user?.user?.role);
  const userLocation = useSelector((state) => state?.user?.user?.location)
  const [userRole, setUserRole] = useState(role);

  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state?.user?.user);
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [showBar, setShowBar] = useState(false);
  const [isFileSizeLarge, setIsFileSizeLarge] = useState(false);
  const [showMessgae, setShowMessage] = useState(true);
  const [uploadFileStatus, setUploadFileStatus] = useState(false);
  const [uploadFileStatusMessage, setUploadFileStatusMessage] = useState("");
  const [privileges, setPrivileges] = useState([]);
  const [location, setLocation] = useState("");
  const [locationName, setLocationName] = useState("Select Work Group");
  const [locationInactive, setLocationInactive] = useState(false)
  const [documentType, setDocumentType] = useState("");
  const userPermissions = useSelector((state) => state?.user?.user?.roles?.permissions);
  const [documentTypeName, setDocumentTypeName] = useState(
    "Select Document Type"
  );
  const [loanNumber, setLoanNumber] = useState("");
  const [dropData, setDropData] = useState({ name: '', toggled: true, children: [] });
  const [dropdownData, setDropdownData] = useState({});
  const [paginations] = useState(pagination.limit);
  const [value, setValue] = useState('');
  const {
    refrence,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(true);
  const [cursor, setCursor] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [isDocumentTypeSelected, setIsDocumentTypeSelected] = useState(false);
  const [label, setLabel] = useState(null)

  // to get location items
  useEffect(() => {
    _getItems();
    _getDocumentTypes();
  }, []);

  const addParentReferences = (node, parent = null) => {
    node.parent = parent;
    if (node.children) {
      node.children.forEach(child => addParentReferences(child, node));
    }
    return node;
  };

  const _getDocumentTypes = async () => {

    dispatch(getDocumentTypes({ limit: pagination.maxlimit, deleted: true }, (res) => {
      let newdata = { ...dropData, children: res?.tree };
      setDropData(newdata);
    }))

  };

  const isLeafNode = (node) => !node.children || node.children.length === 0;

// Helper function to get node's level and index information
const getNodeInfo = (node) => {
  let level = 0;
  let currentNode = node;
  let index = -1; // Initialize as -1
  
  while (currentNode?.parent) {
    level++;
    // Only get the index when we're at the starting node
    if (currentNode === node) {
      index = currentNode.parent.children.findIndex(
        child => child._id === currentNode._id
      );
    }
    currentNode = currentNode.parent;
  }
  
  return { level, index };
};


const CustomHeader = ({ node, style }) => {
  // Only process styling for leaf nodes
  console.log('level index ->', node)
  if (isLeafNode(node)) {
    const { level, index } = getNodeInfo(node);
    
    // For third level (leaf nodes), apply alternating background
    const backgroundColor = level === 3 ? // Assuming level 2 is the leaf level
      (index % 2 === 0 ? '#f3f2ee' : '#ffffff') :
      'transparent';

    return (
      <div
        style={{
          ...style,
          backgroundColor,
          width: "100%",
          // padding: '4px 8px',
          fontSize: 12,
          fontWeight: 'normal',
          borderRadius: '4px',
          transition: 'background-color 0.2s ease'
        }}
        className="sd-childs"
      >
        {node.name}
      </div>
    );
  }

  // For parent nodes
  return (
    <div
      style={{
        ...style,
        padding: '4px 8px',
        fontSize: 12,
        fontWeight: 'bold',
        backgroundColor: 'transparent'
      }}
      className="sd-header"
    >
      {node.name}
    </div>
  );
};

const onClick = (value) => {
  setIsComponentVisible(true);
  const filter = value?.trim();
  
  if (!filter) {
    // Add parent references to the data
    const dataWithParents = addParentReferences({...dropData});
    setDropdownData(dataWithParents);
  } else {
    let filtered = filters.filterTree(dropData, filter);
    filtered = filters.expandFilteredNodes(filtered, filter);
    // Add parent references to the filtered data
    const filteredWithParents = addParentReferences({...filtered});
    setDropdownData(filteredWithParents);
  }
};


  const onFilterMouseUp = ({ target: { value } }) => {
    const filter = value.trim();
    if (!filter) {
      return setDropdownData(dropData);
    }
    let filtered = filters.filterTree(dropData, filter);
    filtered = filters.expandFilteredNodes(filtered, filter);
    // if (filtered.children.length) {
    //   // eslint-disable-next-line array-callback-return
    //   filtered.children.map((item) => {
    //     // eslint-disable-next-line array-callback-return
    //     item.children.map((i) => {
    //       // eslint-disable-next-line array-callback-return
    //       i.children.map((O) => {
    //         setLabel(O._id)
    //       })
    //     })
    //   });
    // } else {
    //   setLabel('')
    // }

    setDropdownData(filtered);
  }


  const onToggle = (node, toggled) => {
    setIsComponentVisible(true);
    
    if (!node.children) {
      setIsDocumentTypeSelected(true);
      setLabel(node._id);
      setValue(node.name);
      setIsComponentVisible(false);
    }
    
    if (cursor) {
      cursor.active = false;
    }
    
    node.active = true;
    if (node.children) {
      node.toggled = toggled;
    }
    
    setCursor(node);
    // Ensure parent references are maintained when updating data
    const updatedData = addParentReferences({...dropdownData});
    setDropdownData(updatedData);
  };

  // const onToggle = (node, toggled) => {
  //   setIsComponentVisible(true)
  //   if (!node.children) {

  //     setIsDocumentTypeSelected(true)
  //     setLabel(node._id);

  //     console.log('node._id', node._id)
  //     let selectOptionPrevs = value;
  //     setValue(node.name)
  //     setIsComponentVisible(false)
  //     // MySwal.fire({
  //     // 	title: 'Are you sure?',
  //     // 	text: "You want to update document type",
  //     // 	icon: 'warning',
  //     // 	showCancelButton: true,
  //     // 	confirmButtonColor: '#3085d6',
  //     // 	cancelButtonColor: '#d33',
  //     // 	confirmButtonText: 'Yes, update it!'
  //     // }).then((result) => {
  //     // 	if (result.isConfirmed) {
  //     // 		dispatch(updateDocumentType({ id: fileData._id, type: node._id }, (res) => {
  //     // 			if (res) {
  //     // 				filterSelectedFn(null)
  //     // 				sortBySelectedFn(null)
  //     // 				setIsDocumentTypeSelected(true)
  //     // 				toast.success('Document type has been updated.', toasterConfig);

  //     // 			}
  //     // 		}))
  //     // 	} else if (result.isDismissed) {
  //     // 		if (selectOptionPrevs) {
  //     // 			setValue(selectOptionPrevs);
  //     // 		} else {
  //     // 			setValue('')
  //     // 			setIsComponentVisible(false)
  //     // 		}

  //     // 	}

  //     // })
  //   }
  //   if (cursor) {
  //     cursor.active = false;
  //   }
  //   node.active = true;
  //   if (!node.name) {
  //     node.toggled = true;
  //   }
  //   else if (node.children) {
  //     node.toggled = toggled;
  //   }
  //   setCursor(node);
  //   setDropdownData(Object.assign({}, dropdownData))
  // }

  const onMouseEnterHandler = () => {
    if (value) {
      const inputBlcElem = document.getElementById('inputBlc');
      const inputBlcElemLeftPosition = document.getElementById('inputBlc').getBoundingClientRect().left;
      const inputBlcElemTopPosition = document.getElementById('inputBlc').getBoundingClientRect().top;
      const labelDropdownElem = document.getElementById('labelTooltip');


      labelDropdownElem.style.left = inputBlcElemLeftPosition + 'px';
      labelDropdownElem.style.top = inputBlcElemTopPosition + 'px';

      setTooltipVisible(true);

      labelDropdownElem.style.marginTop = - labelDropdownElem.clientHeight + 'px';

    }

  }
  const onMouseLeaveHandler = () => {
    if (value) {
      setTooltipVisible(false);
    }
  }


  /**
   * @description method call to modal for adding new location
   */
  const _getItems = async () => {
    dispatch(
      getPrivileges({ status: true }, (res) => {
        setPrivileges(res);
        if (!res?.locations || res?.locations?.length == 0) {
          MySwal.fire({
            title: "No Work Group Available",
            text: "Please Add a Work Group",
            icon: "warning",
            allowOutsideClick: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Okay",
          })
        }
        if (!userLocation) {
          if (res?.locations?.length && res?.locations?.length === 1) {
            setLocation(res?.locations[0]._id);
            setLocationName(res?.locations[0].name);
          }
        } else {
          if (!res?.locations?.find(location => location?._id === userLocation?._id)) {
            setLocationInactive(true)
            MySwal.fire({
              title: "Inactive Work Group",
              text: "Your Work Group is inactive, Please contact Admin",
              icon: "warning",
              allowOutsideClick: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Okay",
            })
          };
          setLocation(userLocation?._id);
          setLocationName(userLocation?.name);
        }

        if (res?.packets?.length) {
          let defaultDocumentType = res?.packets.find((item) => {
            if (item.type === "Packets" || item.type === "packets") {
              return item;
            }
          });
          setDocumentType(defaultDocumentType._id);
          setDocumentTypeName(defaultDocumentType.type);
        }
      })
    );
  };

  /**
   * @description method call to modal for adding new location
   */
  const handleClick = async (val) => {
    setLocation(val.currentTarget.getAttribute("dropdownvalue"));
    setLocationName(val.currentTarget.textContent);
  };

  /**
   * @description method call to modal for adding new location
   */
  const handleDocumentTypeClick = async (val) => {
    setDocumentType(val.currentTarget.getAttribute("dropdownvalue"));
    setDocumentTypeName(val.currentTarget.textContent);
  };

  /*
   * function when drop event occurs
   */
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (userDetail?.purchase_advice && !documentType) {
        toast.error("Please select document type", toasterConfig);
        return;
      }
      if (locationInactive == true) {
        toast.error("Your Work Group is Inactive. Please Contact Admin")
        return
      }
      if (!location) {
        if (privileges?.locations?.length) {
          toast.error("Please assign work group for this document", toasterConfig);
        } else {
          toast.error(
            "Please add WorkGroups from Work Group tab in left menu",
            toasterConfig
          );
        }
        return;
      }
      // if(label === '')
      // {
      //   toast.error(
      //       "This label you provide is not exist the uploaded document goes on unlabeled!",
      //       toasterConfig
      //     );
      //   return;
      // }
      if (acceptedFiles && acceptedFiles.length) {
        /* if (documentTypeName === "Packets" || documentTypeName === "packets") {
           for (const key of Object.keys(acceptedFiles)) {
             if (
               !(
                 acceptedFiles[key]?.type === "application/zip" ||
                 acceptedFiles[key]?.type === "application/x-zip-compressed" ||
                 acceptedFiles[key]?.type === "application/x-zip-compressed" ||
                 acceptedFiles[key]?.type === "multipart/x-zip" ||
                 acceptedFiles[key]?.type === ".zip"
               )
             ) {
               toast.error(
                 "Only zip file type is allowed for Packets.",
                 toasterConfig
               );
               return;
             }
            
           }
         } else {
           for (const key of Object.keys(acceptedFiles)) {
             // if (!(acceptedFiles[key]?.type === "application/zip" || acceptedFiles[key]?.type === "application/x-zip-compressed" || acceptedFiles[key]?.type === "application/x-zip-compressed" || acceptedFiles[key]?.type === "multipart/x-zip" || acceptedFiles[key]?.type === ".zip" || acceptedFiles[key]?.type === "image/png" || acceptedFiles[key]?.type === "application/pdf" || acceptedFiles[key]?.type === "image/jpeg")) {
             // 	toast.error("Only zip, pdf, jpg, jpeg and png file type is allowed for Purchase advice.", toasterConfig);
             // 	return
             // }
 
             //not allow zip files to upload for purchase advice, driver license and HOI
 
             if (
               !(
                 acceptedFiles[key]?.type === "image/png" ||
                 acceptedFiles[key]?.type === "application/pdf" ||
                 acceptedFiles[key]?.type === "image/jpeg"
               )
             ) {
               toast.error(
                 `Only pdf, jpg, jpeg and png file type is allowed for ${documentTypeName}.`,
                 toasterConfig
               );
               return;
             }
 
           }
         } */
        dispatch(
          upload(
            acceptedFiles,
            location,
            documentType,
            label,
            src.fileUpload,
            loanNumber.trim(),
            {
              cancelToken: source.token
            },
            (res) => {
              if (res) {
                setUploadFileStatus(true);
                setUploadFileStatusMessage(res?.message);
              }
            }
          )
        );
        setShowBar(!showBar);
        setSelectedFiles(acceptedFiles);
      }
    },
    [
      showBar,
      location,
      userDetail,
      roleItems,
      privileges?.locations,
      documentType,
      label,
      documentTypeName,
      src,
      loanNumber,
    ]
  );

  /*
   * function to hide the progress bar
   */
  const hideProgressBar = () => {
    source.cancel("Document uploading cancelled");
    toast.success("Document uploading cancelled", toasterConfig);
    source = axios.CancelToken.source();
    setShowBar(!showBar);
  };

  const deleteDocumentType = () => {
    setIsDocumentTypeSelected(false);
    setValue('');
    setLabel(null)
  }

  const customDecorators = {
    ...decorators,
    Header: CustomHeader
  };

  const customTheme = {
    ...defaultTheme,
    tree: {
      ...defaultTheme.tree,
      node: {
        ...defaultTheme.tree.node,
        activeLink: {
          background: '#f0f0f0' // Changed from 'red' to be less aggressive
        }
      }
    }
  };



  /*
   * hook used on browse file event
   */
  const { open } = useDropzone({ onDrop /*, accept: fileType.ZIP*/ });
  return (
    <>
      <PageHeader>Upload File</PageHeader>
      <div className="drag-drop-wrapper">
      <div style={{ textAlign: 'center', color: '#165f81', fontSize: '3em' }}>
          {userDetail?.organization_detail?.name} Upload Portal
        </div>
        <div className="inner  mx-auto d-flex flex-column">
          {showMessgae && isFileSizeLarge && (
            <UploadFileMessage setShowMessage={setShowMessage} />
          )}
          <div
            className={`drag-drop-blc ${showBar ? `uploading-file-blc` : `upload-file-blc`
              }`}
          >
            <Row>
              <Col sm="4">
                <span className="mb-1" style={{ fontSize: "15px", fontWeight: "500", marginBottom: "2px", color: "#8d8d8d" }}>Label </span>
                {((userRole == "business" || userRole == "operator") && privileges?.packets && userDetail?.purchase_advice) ? (
                  <div ref={refrence}>



                    <div className="label-dropdown-blc position-relative">
                      <div className="dropdown-input" id="inputBlc"
                        onMouseEnter={onMouseEnterHandler}
                        onMouseLeave={onMouseLeaveHandler}>
                        <Input
                          className="form-control"
                          value={value}
                          onClick={(e) => { onClick(e.target.value) }}
                          onChange={(e) => { setValue(e.target.value) }}
                          onKeyUp={onFilterMouseUp.bind(this)}
                          placeholder="Select File Label"
                          type="text"

                        />
                        {isDocumentTypeSelected &&
                          <Button color="link" className='close-btn position-absolute p-0' onClick={() => deleteDocumentType()}>
                            <FontAwesomeIcon icon={faClose} />
                          </Button>
                        }
                        {
                          value ? <div
                            className={`label-tooltip position-fixed ${tooltipVisible ? 'active' : ''}`}
                            style={{left: "30%", top: "179.4px", marginTop: "-29px"}}
                            id="labelTooltip" >
                            {value}
                          </div> : ''
                        }

                      </div>
                      {dropdownData?.children?.length !== 0 && isComponentVisible ? <Treebeard data={dropdownData} onToggle={onToggle} decorators={ customDecorators} defaultTheme={customTheme} /> : null}
                    </div>
                  </div>
                ) : ((userRole == "subadmin" || userRole == "superadmin") && userPermissions?.some((permission) => permission?.SLUG == "document_management") ?
                  <div className="label-dropdown-blc position-relative" ref={refrence}>
                    <div className="input-blc" id="inputBlc"
                      onMouseEnter={onMouseEnterHandler}
                      onMouseLeave={onMouseLeaveHandler}>
                      <Input
                        className="form-control"
                        value={value}
                        onClick={(e) => { onClick(e.target.value) }}
                        onChange={(e) => { setValue(e.target.value) }}
                        onKeyUp={onFilterMouseUp.bind(this)}
                        placeholder="Select File Label"
                        type="text"

                      />
                      {
                        value ? <div
                          className={`label-tooltip position-fixed ${tooltipVisible ? 'active' : ''}`}
                          id="labelTooltip">
                          {value}
                        </div> : ''
                      }

                    </div>
                    {dropdownData?.children?.length !== 0 && isComponentVisible ? <Treebeard data={dropdownData} onToggle={onToggle} decorators={customDecorators} defaultTheme={customTheme} /> : null}
                  </div> : "")}

              </Col>

              {/*<Col sm="4">
                {((userRole == "business" || userRole == "operator") && privileges?.packets && userDetail?.purchase_advice) ? (
                  <DocumentType
                    options={privileges?.packets}
                    _handleClick={handleDocumentTypeClick}
                    label={documentTypeName}
                  />
                ) : ((userRole == "subadmin" || userRole == "superadmin") && userPermissions?.some((permission) => permission?.SLUG == "document_management") ? <DocumentType
                options={privileges?.packets}
                _handleClick={handleDocumentTypeClick}
                label={documentTypeName}
              /> : "")}
              </Col>*/}
              <Col sm="4">
                {privileges?.locations && (
                  <DropdownList
                    options={privileges?.locations}
                    disabled={userLocation ? true : false}
                    _handleClick={handleClick}
                    locationName={userLocation ? userLocation.name : locationName}
                  />
                )}
              </Col>
              <Col sm="4">
                <span className="mb-1" style={{ fontSize: "15px", fontWeight: "500", marginBottom: "2px", color: "#8d8d8d" }}>Loan Number </span>
                <Input
                  style={{ height: "43px", marginTop: "2px", marginBottom: "11px" }}
                  type="text"
                  value={loanNumber}
                  placeholder="Loan Number"
                  onChange={(e) => {
                    setLoanNumber(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <div className="my-auto">
              <div className="card d-flex align-items-center justify-content-center flex-fill position-relative">
                <Dropzone
                  onDrop={onDrop}
                  multiple={true}
                  disabled={showBar}
                //	maxFiles={1}
                //	accept={fileType.ZIP}
                >
                  {({ getRootProps, getInputProps }) => (
                    <>
                      <div className="inner-blc">
                        <div
                          {...getRootProps()}
                          className="flex-fill d-flex align-items-center justify-content-center dragzone-blc"
                        >
                          <input {...getInputProps()} />
                        </div>
                        <HeadBlock showFolder={showBar} />
                        {!showBar && (
                          <>
                            <div
                              className={`or-bloc d-flex justify-content-center align-items-center`}
                            >
                              <span>OR</span>
                            </div>
                            <div className="text-center">
                              <Button
                                color="primary"
                                className="choose-file-btn"
                                onClick={open}
                              >
                                Browse files
                              </Button>
                            </div>
                          </>
                        )}
                        {selectedFiles && showBar ? (
                          <UploadedFile
                            selectedFiles={selectedFiles}
                            showBar={showBar}
                            handleProgressBar={hideProgressBar}
                            setIsFileSizeLarge={setIsFileSizeLarge}
                            uploadFileStatus={uploadFileStatus}
                            uploadFileStatusMessage={uploadFileStatusMessage}
                          />
                        ) : null}
                      </div>
                    </>
                  )}
                </Dropzone>
              </div>
              {/* <div className="card d-flex align-items-center justify-content-center flex-fill position-relative">
								<Button className="position-relative upload-api-btn">
									<Input className="position-absolute" />
									Upload From API
								</Button>
							</div> */}
            </div>
          </div>
          {/* <UploadTime /> */}
        </div>
      </div>
    </>
  );
};

export default FileUpload;
